export default __webpack_public_path__ + "static/media/apple.7843296a.svg";